import { TDropdownOption } from '@/shared/Inputs/DropdownInput/dropdown.types.ts'

const mdmDataTypeOptions: TDropdownOption[] = [
  {
    title: 'Строка',
    value: 'STRING',
  },
  {
    title: 'Текст',
    value: 'TEXT',
  },
  {
    title: 'Число',
    value: 'NUMERIC',
  },
  {
    title: 'Дата',
    value: 'DATE',
  },
  {
    title: 'Логический',
    value: 'BOOLEAN',
  },
]
export default mdmDataTypeOptions
